<template>
    <div class="copy-create">
        <InfoHeader title="计划复制" @backPage="handleBackPage" :style="{position: 'fixed', zIndex: '99', top: '51px', width: '100%', transform: 'translateX(-10px)'}" >
            <div>
                <el-button type="primary" size="mini" :loading="btnLoading" class="ml40"
                 v-matomo="{behaviorCategory: 'OPPO(计划复制)',  name: '计划复制(提交并保持在当前)' }"
                @click="handleSubmit('back')">提交并返回列表</el-button>
                <el-button type="success" size="mini" :loading="btnLoading" class="ml20" 
                v-matomo="{behaviorCategory: 'OPPO(计划复制)',  name: '计划复制(提交并保持在当前)' }"
                @click="handleSubmit()">提交并保持在当前</el-button>
            </div>
        </InfoHeader>
        <div class="copy-create-content p10">
            <el-alert
                class="alert-border"
                :closable="false"
                show-icon
                type="warning">
                <p slot="title" class="text-color-333 font12px">
                    <span class="text-bold text-color-error">重要提示：</span>
                    受媒体限制，若<span class="text-bold">需要设置定向</span>，请<span class="text-bold">选择定向包使用</span>，勿调用未使用定向包的计划，未使用定向包会导致调用和创建的广告组<span class="text-bold">统一定向</span>（修改任何一个定向条件，其他的广告组都会改变）。
                </p>
            </el-alert>
            <el-row :gutter="20" style="margin-top: 10px;">
            <el-col :span="14">
                <div>
                    <!-- :config="selectedAccounts" -->
                    <copyPlan ref="plan" :info="info" :config="selectedAccounts"  @addPlan="handleAddPlan" />
                    <copyConfig ref="config" :config="configData" />

                </div>
            </el-col>
            <el-col :span="10">
                <div class="grid-select-content">
                    
                    <div class="grid-select-content-header">
                        <div class="grid-select-content-header-left font14px text-bold">
                            已选账户与计划<span class="font12px text-normal">（计划数：{{selectedAccountsLength}}）</span>
                        </div>
                        <div class="grid-select-content-header-right">
                            <el-button type="danger" size="mini" @click="clearSelectedAccounts">清空</el-button>
                        </div>
                    </div>

                    <div class="grid-select-content-body">
                        <!-- 使用虚拟列表组件 -->
                        <VirtualList
                            :data-key="'id'"
                            :data-sources="selectedAccounts"
                            :data-component="itemComponent"
                            :estimate-size="22"
                            :keeps="50"
                            :extra-props="{
                                del: true,
                            }"
                            style="max-height: calc(100vh - 300px);overflow: auto;"
                        >
                        </VirtualList>
                    </div>

                </div>
            </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import InfoHeader from "../components/infoHeader.vue";
    import copyConfig from "../components/copyConfig.vue";
    import copyPlan from "../components/copyPlan.vue";
    import Item from "../components/itemComponent.vue";
    import VirtualList from 'vue-virtual-scroll-list'; // 引入虚拟列表组件
    import API from '@/api/marketManage/oppoCopyPlan.js'
    import _ from 'lodash'

    export default {
        name: "copyInfoPage",
        components: {
            InfoHeader,
            copyConfig,
            copyPlan,
            VirtualList
        },
        data() {
            return {
                btnLoading: false,
                itemComponent: Item,
                // 定义选中的账户和计划数据
                selectedAccounts: [],
                info:[], // 复制的信息
                // Array.from({ length: 2000 }, (_, accountIndex) => {
                //     const accountId = accountIndex + 1;
                //     return {
                //         id: accountId,
                //         name: `账户名称${accountId}`,
                //         plans: Array.from({ length: 2 }, (_, planIndex) => {
                //             const planId = `${accountId}-${planIndex + 1}`;
                //             return { 
                //                 id: planId, 
                //                 name: `计划名称${planId}` 
                //             };
                //         })
                //     };
                // }),
                type: '',
                configData: {}
            };
        },
        computed: {
            selectedAccountsLength() {
                return this.selectedAccounts.reduce((total, account) => {
                    return total + account.children.length;
                }, 0);
            }
        },
        created() {
            this.type = this.$route.params.type;
            if(this.type == 'copy') {
                this.getInfo()
            }
        },
        mounted() {
            this.$bus.$on('del', this.handleDel);
        },
        methods: {
            handleBackPage() {
                this.$router.go(-1)
            },
            removeNodeById(tree, id) {
                const removeRecursive = (nodes) => {
                    for (let i = nodes.length - 1; i >= 0; i--) {
                        const node = nodes[i];
                        // 先递归处理子节点
                        if (node.children && node.children.length > 0) {
                            removeRecursive(node.children);
                            // 如果子节点被清空，则删除children属性
                            if (node.children.length === 0) {
                                delete node.children;
                            }
                        }
                        // 然后处理当前节点
                        if (node.id == id) {
                            nodes.splice(i, 1);
                        }
                    }
                };
            
                removeRecursive(tree);
                
                // 再次检查并删除没有子节点的父节点
                for (let i = tree.length - 1; i >= 0; i--) {
                    const node = tree[i];
                    if (!node.children || node.children.length === 0) {
                        tree.splice(i, 1);
                    }
                }
                
                return tree;
            },
            // 清空单独的账户或计划
            handleDel(id) {
                let updata_list = this.removeNodeById(this.selectedAccounts, id);
                this.selectedAccounts = updata_list
            },
            // 清空选中的账户和计划数据
            clearSelectedAccounts() {
                this.selectedAccounts = [];   
            },
            handleAddPlan(params) {
                const { plan, disabledList } = params;
                let mergedArray = [...this.selectedAccounts];
                plan.forEach(newItem => {
                    const existingIndex = mergedArray.findIndex(item => item.id == newItem.id);
                    if (existingIndex !== -1) {
                        // 如果存在相同 id 的对象，合并 label 数组
                        mergedArray[existingIndex].children = [
                            ...mergedArray[existingIndex].children,
                            ...newItem.children
                        ];
                    } else {
                        // 如果不存在相同 id 的对象，直接添加
                        mergedArray.push(newItem);
                    }
                });

                disabledList.forEach(newItem => {
                    const existingIndex = mergedArray.findIndex(item => item.id == newItem.id);
                    if (existingIndex !== -1) {
                        mergedArray[existingIndex].children.map(item => {
                            newItem.children.map(v => {
                                if(item.id == v.id) {
                                    item.label = v.label
                                }
                            })
                        })
                    }
                });
                // 对每个对象的 children 数组按 id 去重
                const result = mergedArray.map(item => {
                    return {
                        ...item,
                        children: _.uniqBy(item.children, 'id')
                    };
                });
                this.selectedAccounts = result
            },
            async getCurrentChangeStates() {
                let init_info = {..._.omit(this.configData, ['type', 'date']), account_info:this.info}
                let config = await this.$refs.config.submitForm();
                let diff = {
                    account_info:this.selectedAccounts,
                    ..._.omit(config, ['type', 'date'])
                }
                let isEqual = _.isEqual(init_info, diff)
                return isEqual
            },
            handleSubmit: _.throttle(async function (type) {
                if(!this.selectedAccountsLength) {
                    this.$message.warning('已选账户与计划为空，无法复制，请选择要复制的计划');
                    return
                }
                await this.$refs.plan.submitForm();
                let config = await this.$refs.config.submitForm();
                let account_info = this.selectedAccounts.map(item => {
                    return {
                        account_id:item.id,
                        account_name:item.label,
                        plan_list:item?.children.map(plan => {
                            return {
                                plan_id:plan.id,
                                plan_name:plan.label
                            }
                        })
                    }
                })
                this.btnLoading = true;
                API.postSavePlan({
                    account_info,
                    ...(this.type == 'copy' && { from_copy_id: this.$route.query?.id }),
                    ..._.omit(config, ['type', 'date'])
                }).then(res => {
                    this.$message.success(res.info || '成功');
                    if(type) {
                        this.$emit('refresh', true);
                        this.$router.replace({
                            name: 'oppo_plan_copy',
                            params: {
                                type: 'list'
                            }
                        })
                    }else{
                        this.$emit('refresh', false);
                    }
                }).catch(err => {
                    if(err.code == 403) {
                        this.$notify.error({
                            title: '提示',
                            message: err.info || '错误'
                        });
                    }else{
                        this.$message.error(err.info || '错误');
                    }
                }).finally(() => {
                    this.btnLoading = false;
                })
            }, 3 * 1000),
            getInfo() {
                this.btnLoading = true;
                API.getTaskInfo({copy_id: this.$route.query.id}).then(res => {
                    let result = res.data.source_account_plan_info.map(v=> {
                        return {
                            id: Number(v.account_id),
                            label: v.account_name,
                            children: v.plan_list.map(v=> {
                                return {
                                    id: Number(v.plan_id),
                                    label: v.plan_name
                                }
                            })
                        }
                    })
                    this.selectedAccounts = result
                    this.info = result
                    this.configData = {new_status: res.data.new_status, old_status: res.data.old_status, start_date:res.data.start_date,
                        end_date:res.data.end_date,
                        date: [res.data.start_date, res.data.end_date]}
                }).finally(() => {
                    this.btnLoading = false;
                })
            },
            leave() {
                this.$confirm('您确定要离开吗？', '温馨提示', {
                        confirmButtonText: '离开',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        next();
                    }).catch(() => {
                        next(false);
                });
            }
        },
        
        beforeDestroy() {
            // this.leave()
        },
    }
</script>
<style lang="scss" scoped>
    .copy-create-content{
        background: #fff;
    }
    .grid-select-content{
        padding: 10px 0;
        box-shadow: 0 0 4px 0 rgba(0,0,0,.4);
        .grid-select-content-header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #DCDFE6;
            padding: 0 10px 10px 10px;
        }
        .grid-select-content-body{
            padding: 10px;
            // max-height: calc(100vh - 300px);
            // overflow: auto;
        }
    }
</style>